import { SET_NOTIFICATIONS, SET_ERRORS, LOADING_NOTIFICATION, DELETE_NOTIFICATION } from '../types'
import { addRealTimeDocument, updateRealtimeDocument, updateOverview } from '../index'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
toast.configure()

function compareByCreationDate(a, b) {
  if (a.createdAt > b.createdAt) return -1
  if (b.createdAt > a.createdAt) return 1
  return 0
}
// export const template = () => {
//     return  (dispatch, getState, { getFirebase, getFirestore }) => {
// const firebase = getFirebase()
// const firestore = getFirestore()
//     }
// }

export const getNotifications = (setUnsubscribe) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore()
    let userId = getState().user.credentials.id
    dispatch({ type: LOADING_NOTIFICATION })
    let unsubscribe = firestore
      .collection('Notifications')
      .where('receivers', 'array-contains', userId)
      .onSnapshot(
        (snapshot) => {

          const notifications = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          notifications.sort(compareByCreationDate)
          dispatch({
            type: SET_NOTIFICATIONS,
            payload: notifications,
          })
          snapshot.docChanges().forEach((change) => {
            let docId = change.doc.id
            let docStatus = change.doc.data().docStatus
            let senderId = change.doc.data().senderId
            let canRead = change.doc.data().canRead

            let type = userId === senderId ? 'docFromYou' : 'docToYou'

            if (change.type === 'added') {
              console.log('New document ', docStatus, new Date())
              dispatch(
                updateOverview({
                  type,
                  status: docStatus,
                })
              )

              dispatch(addRealTimeDocument(docId, docStatus, senderId))
            }
            if (change.type === 'modified') {
              console.log('Modified document ', docStatus, new Date())
              if (docStatus !== 'Pending' && canRead) {
                dispatch(
                  updateOverview({
                    type,
                    status: docStatus,
                  })
                )
              }

              dispatch(updateRealtimeDocument(docId, docStatus))
            }
          })
        },

        (error) => {
          console.log(error)
          toast.error(error.message, { autoClose: 2500, position: 'bottom-right' })
          dispatch({
            type: SET_ERRORS,
            payload: error.message,
          })
        }
      )
    setUnsubscribe(unsubscribe)
  }
}

export const deleteNotification = (docStatus, notificationId, userId) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase()
    const firestore = getFirestore()

    if (docStatus === 'Completed' || docStatus === 'Rejected' || docStatus === 'Expired') {
      firestore
        .collection('Notifications')
        .doc(notificationId)
        .update({
          receivers: firebase.firestore.FieldValue.arrayRemove(userId),
          canRead: false,
        })
        .then(() => {
          dispatch({
            type: DELETE_NOTIFICATION,
            payload: notificationId,
          })
          // console.log(`User id removed from ${docStatus} alert notification successfully`)
        })
        .catch((error) => {
          dispatch({
            type: SET_ERRORS,
            payload: error.message,
          })
        })
    }
  }
}
